module.exports = __webpack_public_path__ + "img/vitality-money-Gold.9120152b.svg";